<template>
  <div>
    <div v-if="title" class="text-h3 mb-2">
      {{ title }}
    </div>
    <v-row no-gutters>
      <v-col
        v-for="(insuranceCompany, indexIC) in insuranceCompanies"
        :key="indexIC"
        cols="12"
        sm="6"
        class="mt-2"
        :class="{
          'pr-4': !(indexIC % 2) && $vuetify.breakpoint.smAndUp
        }"
      >
        <div
          class="provider rounded d-flex align-center border cursor-pointer"
          data-cy="healthInsuranceProviderBenefitsListContentSelectedProvider"
          :class="{
            'selected-provider': selectedInsuranceCompany === +insuranceCompany.id
          }"
          @click="selectedInsuranceCompany = +insuranceCompany.id"
        >
          <div v-if="selectedInsuranceCompany === +insuranceCompany.id" class="selected-icon">
            <v-icon width="24" height="24" class="pa-1 white--text rounded-tr rounded-bl">
              $tick
            </v-icon>
          </div>
          <v-img
            eager
            :src="
              $asset(
                `img/logos/healthInsuranceProviders/${insuranceCompany.additionalInfo.slug}.svg`
              )
            "
            :alt="getLocaleText(insuranceCompany.altText)"
            max-width="128"
            max-height="42"
            class="mx-auto"
            contain
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'HealthInsuranceProviderBenefitsListContent',
  props: {
    title: {
      type: String,
      required: false
    },
    insuranceCompanies: {
      type: Array,
      required: true
    }
  },
  computed: {
    selectedInsuranceCompany: {
      get() {
        return this.$store.state.profile.healthInsuranceProviderBenefit.selectedInsuranceCompany;
      },
      set(value) {
        this.$store.commit(
          'profile/healthInsuranceProviderBenefit/setSelectedInsuranceCompany',
          value
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#app .provider {
  box-shadow: 0 8px 10px -5px rgba($grey-lighten, 0.25);
  position: relative;
  height: 104px;

  &:hover,
  &:focus,
  &:active {
    box-shadow: none;
    border-color: $primary !important;
  }

  .selected-icon {
    position: absolute;
    top: -0.5px;
    right: -0.5px;

    .v-icon {
      background-color: $primary;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: -20px;
      right: 0;
      width: 10px;
      height: 20px;
      background: transparent;
      border-top-right-radius: 11px;
      box-shadow: 0 -11px 0 0 $primary;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -20px;
      width: 20px;
      height: 10px;
      background: transparent;
      border-top-right-radius: 11px;
      box-shadow: 11px 0 0 0 $primary;
    }
  }

  &.selected-provider {
    box-shadow: none;
    border-color: $primary !important;
  }
}
</style>
